var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-row',{attrs:{"justify":"center"}},[_c('h2',[_vm._v("Request New Test")])]),_c('v-row',{staticClass:"error--text mt-3",attrs:{"justify":"center"}},[_vm._v(_vm._s(_vm.error))]),_c('v-row',[_c('v-col',[_c('iframe',{staticClass:"intake-form-frame",attrs:{"src":_vm.intakeFormUrl,"frameborder":"0"}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }